import { QueryState, RequestFormStep } from 'common/enums';
import { Nullable } from 'utils/Nullable';
import { StackableStep } from 'components/fragments/StackableSteps';
import { IncidentsInterface } from 'interfaces/incident.interface';
import {
  defaultRequestFormData,
  RequestFormData,
} from '../../../pages/Dashboard/ResourceRequest/hooks/useRequestForm';

export interface IRequestsState {
  state: QueryState;
  loading: boolean;
  success: boolean;
  steps: StackableStep[];
  newRequestNumber: number;
  agencyCount: number;
  error: Nullable<string> | undefined;
  requestForm: RequestFormData;
  incidents: IncidentsInterface;
}

export const RequestsEmptyState: IRequestsState = {
  state: QueryState.UNDEFINED,
  loading: false,
  success: false,
  error: null,
  newRequestNumber: 0,
  agencyCount: 0,
  requestForm: defaultRequestFormData,
  incidents: {} as IncidentsInterface,
  steps: [
    {
      step: RequestFormStep.REQUEST_DETAILS,
      title: 'Request details',
      active: true,
    },
    {
      step: RequestFormStep.AMBULANCE,
      title: 'Add ambulance',
      active: false,
    },
    {
      step: RequestFormStep.PERSONNEL,
      title: 'Add personnel',
      active: false,
    },
    {
      step: RequestFormStep.REGIONS,
      title: 'Additional details',
      active: false,
    },
    {
      step: RequestFormStep.SEND_REQUEST,
      title: 'Send request',
      active: false,
    },
  ],
};
